import { useLocation } from 'react-router-dom'
import { useEffect, Fragment } from 'react'
import { useLazyQuery, gql } from '@apollo/client'

import { ReactComponent as DownloadIcon } from '../assets/icons/download-icon.svg'
import { ReactComponent as DocumentIcon } from '../assets/icons/document-icon.svg'
import PDFDisplay from '../components/PDFDisplay'

const TipsToolsDetail = () => {
  let location = useLocation()
  const page = location.pathname.split('/').pop()
  const GET_TIPSTOOLS_ITEMS = gql`
  query TipsToolsItems {
    tipsToolsItems(where: {postId: "${page}"}) {
      edges {
        node {
          databaseId
          order
          postId
          title
          detail {
            resources {
              name
              type
              url
            }
          }
        }
      }
    }
  }
`
  const [
    getTipsToolsItems,
    {
      loading: tipsToolsItemsDataLoading,
      error: tipsToolsItemsDataError,
      data: tipsToolsItemsData,
    },
  ] = useLazyQuery(GET_TIPSTOOLS_ITEMS, {
    fetchPolicy: 'no-cache',
  })
  const tipsToolsItems =
    tipsToolsItemsData?.tipsToolsItems?.edges?.map((edge) => edge.node) ?? []
  const tipsToolsItem = tipsToolsItems[0] ?? null

  useEffect(() => {
    getTipsToolsItems()
  }, [getTipsToolsItems])

  return (
    <main className="min-h-[calc(100vh-200px)] overflow-hidden">
      <div className="container mb-[120px] max-w-screen-tipstools pt-14 sm:px-0">
        <div className="relative pb-[10px]">
          <div className="absolute -right-[150px] top-0 -z-[1] h-[395px] w-[217px] bg-none bg-contain bg-right-top bg-no-repeat opacity-20 sm:bg-tipstools-background lg:-right-[80px] xl:-right-[100px]"></div>
          {tipsToolsItemsDataLoading || !tipsToolsItemsData ? (
            <LoadingSkeleton />
          ) : tipsToolsItems.length === 0 ? (
            <p className="text-center">No data</p>
          ) : (
            <>
              <h1
                className="mb-10 text-center text-4xl font-bold text-skin-accent"
                dangerouslySetInnerHTML={{
                  __html: tipsToolsItem?.title ?? '<div></div>',
                }}
              />

              {Array.isArray(tipsToolsItem?.detail?.resources) &&
                tipsToolsItem.detail.resources.map(
                  (resource, resourceIndex) => {
                    if (resource.type === 'PDF') {
                      return (
                        <PDFDisplay
                          key={`${resourceIndex}${resource.name ?? ''}`}
                          url={resource.url ?? ''}
                        />
                      )
                    } else if (resource.type === 'INTERACTIVE') {
                      return (
                        <div
                          key={`${resourceIndex}${resource.name ?? ''}`}
                          className="aspect-video"
                        >
                          <iframe
                            className="h-full w-full"
                            title={resource.name ?? ''}
                            src={resource.url}
                          ></iframe>
                        </div>
                      )
                    } else if (resource.type === 'IMAGE') {
                      return (
                        <div
                          key={`${resourceIndex}${resource.name ?? ''}`}
                          className="flex w-full justify-center"
                        >
                          <img src={resource.url ?? ''} alt="" />
                        </div>
                      )
                    } else {
                      return (
                        <Fragment
                          key={`${resourceIndex}${resource.name ?? ''}`}
                        ></Fragment>
                      )
                    }
                  }
                )}

              <div className="mt-8 flex justify-center px-8 sm:px-24">
                {Array.isArray(tipsToolsItem?.detail?.resources) &&
                  tipsToolsItem.detail.resources.map(
                    (resource, resourceIndex) => {
                      return ['PDF', 'EXTERNAL', 'IMAGE'].includes(
                        resource.type
                      ) ? (
                        <a
                          key={`${resourceIndex}${resource.name ?? ''}`}
                          href={resource.url ?? ''}
                          target="_blank"
                          rel="noreferrer"
                          className="flex min-w-[375px] items-center justify-between gap-2 rounded-[10px] border-2 bg-white px-4 py-5 text-xs font-bold text-flame active:translate-y-[0.75px] active:scale-[0.99]"
                        >
                          <div className="flex items-center">
                            <DocumentIcon className="mr-4 w-[30px] [&_g_*]:!stroke-flame" />
                            <span>{resource.name ?? ''}</span>
                          </div>
                          <DownloadIcon className="w-[18px] [&_g_*]:!stroke-flame" />
                        </a>
                      ) : (
                        <></>
                      )
                    }
                  )}
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  )
}

const LoadingSkeleton = () => {
  return (
    <div role="status" className="animate-pulse space-y-2.5">
      {/** Title */}
      <div className="mb-8 flex w-full items-center justify-center space-x-2">
        <div className="mb-[28px] mt-[28px] h-2.5 w-2/5 rounded-full bg-gray-300 dark:bg-gray-700"></div>
      </div>
      {/** Resources */}
      <div className="flex w-full items-center justify-center">
        <div className="h-[84px] w-[408px] rounded-[10px] bg-gray-300 dark:bg-gray-700"></div>
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  )
}

export default TipsToolsDetail
